export default __webpack_public_path__ + "ccab74118c3da703069d5e3dd43fe160.png";